import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Header,
  Information,
  JourneyContainer,
  Progress,
  Requirements,
  TitleBar
} from './kelsey-journey-styles';
import InfoContainer from './InfoContainer';
import { FormContainer } from './InfoContainer/info-container-styles';
import BasicRequirementsForm from './Forms/BasicRequirementsForm';
import TourDetailsInfo from './InfoCards/TourDetailsInfo';
import BasicRequirementsInfo from './InfoCards/BasicRequirementsInfo';
import UnitAssignmentInfo from './InfoCards/UnitAssignmentInfo';
import ProgressBar from '../ProgressBar';
import Popup from '../../../globalcomponents/Popup';
import PopupTitle from '../../../globalcomponents/PopupComponents/PopupHeader';
import PopupBody from '../../../globalcomponents/PopupComponents/PopupBody';
import ReactRetool from 'react-retool';
import { getCookie } from '../../../utils';
import { GlobalContext } from '../../../utils/ContextProviders/GlobalContextProvider';

const KelseyJourney = ({
  leadData,
  propertyData,
  schedule,
  leadUpdateMutate,
  setIsTabOpen,
  enableBot,
  handlePNAExpansionToggle
}) => {
  const Tabs = {
    BasicRequirements: 1,
    UnitAssignment: 2,
    TourBooking: 3
  };
  const { setUnit } = useContext(GlobalContext);
  const [isEditing, setIsEditing] = useState(false);
  const [tab, setTab] = useState(0);
  const [pnaOpen, setPnaOpen] = useState(false);
  const updateEditing = tab => {
    setIsEditing(prevState => !prevState);

    setTab(tab);
  };
  const authorization = `${getCookie('rb_access_token')}`;
  useEffect(() => {
    if (isEditing) {
      setIsTabOpen(true);
    } else {
      setIsTabOpen(false);
    }
  }, [isEditing]);
  const hasEffectRun = useRef(false);
  useEffect(() => {
    if (
      !hasEffectRun.current &&
      leadData?.preference?.unitName &&
      propertyData
    ) {
      setUnit({
        ...propertyData.find(
          ({ unitName }) => unitName === leadData.preference.unitName
        )
      });
      hasEffectRun.current = true;
    }
  }, [propertyData, leadData]);
  const checkIsEditing = inpTab => {
    return isEditing && tab === inpTab;
  };

  const hasConfirmedTour = Array.isArray(schedule)
    ? schedule.some(s => s?.confirmedDate)
    : false;

  const getProgressValByContext = () => {
    const preference = leadData?.preference;
    if (preference?.unitName) {
      if (hasConfirmedTour) return 100;
      return 55;
    } else if (preference?.bedroom && preference?.bathroom) {
      return 50;
    }
    return 0;
  };

  const onCLosePna = () => {
    setPnaOpen(false);
  };
  return (
    <>
      {pnaOpen ? (
        <Popup
          width={'900px'}
          maxHeight="600px"
          minHeight="600px"
          onClose={onCLosePna}
          show={pnaOpen}
        >
          <PopupTitle fontSize={'16'} onClose={onCLosePna}>
            Global Price and Availability
          </PopupTitle>
          <PopupBody padding={'0px'}>
            <ReactRetool
              url={import.meta.env.VITE_RETOOL_PNA}
              data={{
                authorization
              }}
              height="530px"
            />
          </PopupBody>
        </Popup>
      ) : null}
      <JourneyContainer>
        <TitleBar>
          <Header>Kelsey's State</Header>
        </TitleBar>
        <Requirements>
          <Progress>
            {enableBot && (
              <ProgressBar
                length={272}
                color="#67C848"
                value={getProgressValByContext()}
              />
            )}
          </Progress>
          <Information>
            {checkIsEditing(Tabs.BasicRequirements) && enableBot ? (
              <FormContainer>
                <BasicRequirementsForm
                  leadData={leadData}
                  leadUpdateMutate={leadUpdateMutate}
                  onClose={() => {
                    setTab(0);
                    setIsEditing(false);
                  }}
                />
              </FormContainer>
            ) : null}
            {enableBot ? (
              <InfoContainer
                tab={Tabs.BasicRequirements}
                topic="Basic Requirements"
                onEdit={updateEditing}
              >
                <BasicRequirementsInfo leadData={leadData} />
              </InfoContainer>
            ) : null}

            <InfoContainer
              tab={Tabs.UnitAssignment}
              topic="Unit Assignment"
              secondary
              setPnaOpen={setPnaOpen}
              onEdit={e => handlePNAExpansionToggle(e)}
            >
              <UnitAssignmentInfo
                leadData={leadData}
                propertyData={propertyData}
              />
            </InfoContainer>

            {enableBot ? (
              <InfoContainer tab={Tabs.TourBooking} topic="Tour Details">
                <TourDetailsInfo schedule={schedule} />
              </InfoContainer>
            ) : null}
          </Information>
        </Requirements>
      </JourneyContainer>
    </>
  );
};

export default KelseyJourney;
